import { fromJS, Record } from 'immutable';
import { AddressData } from '../../geolocation-data/models/address-data.model';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';

export const APPOINTMENT_CONTACT_SCHEMA = Object.freeze({
  NAME: '',
  PHONE: '',
  EMAIL: '',
  ADDRESS: '',
  ADDRESS_DATA: AddressData,
});
const RECORD = generateSchema(APPOINTMENT_CONTACT_SCHEMA);
const KEYS: any = generateKeys(APPOINTMENT_CONTACT_SCHEMA);

export class AppointmentContact extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    return setInModel(this, [
      {
        key: KEYS.ADDRESS_DATA,
        value: props.get(KEYS.ADDRESS_DATA)
          ? new AddressData(this.addressData)
          : null,
      },
    ]) as AppointmentContact;
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get phone(): string {
    return this.get(KEYS.PHONE);
  }

  get email(): string {
    return this.get(KEYS.EMAIL);
  }

  get address(): string {
    return this.get(KEYS.ADDRESS);
  }

  get addressData(): AddressData {
    return this.get(KEYS.ADDRESS_DATA);
  }
}
